import React from "react";
import { useNavigate } from "react-router-dom";
import MonthlyShiftRegistration from "../components/MonthlyShiftRegistration";

/**
 * 社員向け：月次スケジュール登録
 */
export default function EmployeeSchedule() {
  const navigate = useNavigate();
  return (
    <MonthlyShiftRegistration
      onBack={() => navigate("/card_back")}
      onRegistrationComplete={() => navigate("/card_back")}
    />
  );
}
